import { Href, Redirect, useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function Page() {
  const { id } = useLocalSearchParams<{ id: string[] }>();
  const { tab } = useLocalSearchParams();
  return (
    <Redirect
      href={`/accounts/${id.toString()}?tab=${tab.toString()}` as Href}
    />
  );
}
